import Elemento from "./Elemento.js";

export default class Side extends Elemento {
  constructor() {
    super();
    this.grupos = new Array();
    this.GetCampo = function (cod) {
      var campo = null;
      var campos;

      this.grupos.forEach((grupo) => {
        campos = grupo.campos.filter((campo) => campo.cod == cod);
        if (campos.length > 0) {
          campo = campos[0];
        }
      });

      return campo;
    };
  }
}
